import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

export default function CTA() {
  return (
    <section className="bg-obsidian text-cream relative grain py-28 md:py-40" data-testid="cta">
      <div className="relative z-10 mx-auto max-w-[1200px] px-5 md:px-10 text-center">
        <Reveal>
          <span className="font-sans uppercase tracking-[0.35em] text-[11px] text-amber">Begin your ritual</span>
          <h2 className="mt-6 font-serif text-5xl md:text-8xl leading-[0.9]">
            Your best hair<br /><span className="italic text-amber">starts here.</span>
          </h2>
          <p className="mt-8 max-w-xl mx-auto font-sans font-light text-cream/65 leading-relaxed">
            Take the 60-second AI scalp analysis or book a consultation with our
            trichologists — and let science and nature do the rest.
          </p>
          <div className="mt-12 flex flex-wrap gap-4 justify-center">
            <Link to="/analysis" className="group inline-flex items-center gap-2 bg-cream text-obsidian px-9 py-4 font-sans uppercase tracking-[0.2em] text-xs hover:bg-amber hover:text-cream transition-colors">
              Start AI analysis
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
            <Link to="/consultation" className="inline-flex items-center gap-2 border border-cream/25 px-9 py-4 font-sans uppercase tracking-[0.2em] text-xs hover:bg-cream/10 transition-colors">
              Book consultation
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
